import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { getAllGates } from "@/api";
import { GateRead } from "@types";

export function useAllGates() {
  const {
    data,
    error,
    isLoading: loading,
    refetch,
  } = useQuery<AxiosResponse<GateRead[]>>({
    queryKey: ["gates"],
    queryFn: getAllGates,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });

  return {
    data: data?.data ?? [],
    total: data?.data?.length ?? 0,
    loading,
    error,
    refetch,
  };
}
